"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisFormElementIsolatedAnswer = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var IpisFormElement_1 = require("./IpisFormElement");
var FormElementAnswer_1 = require("./FormElementAnswer");
var IpisFormElementIsolatedAnswer;
(function (IpisFormElementIsolatedAnswer) {
    IpisFormElementIsolatedAnswer.MultipleChoiceSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.MultipleChoiceSchema.shape.typeOfQuestion,
        answer: FormElementAnswer_1.FormElementAnswer.MultipleChoiceFormAnswer(),
    });
    IpisFormElementIsolatedAnswer.YesNoSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.YesNoSchema.shape.typeOfQuestion,
        answer: FormElementAnswer_1.FormElementAnswer.YesNoFormAnswerSchema(),
    });
    IpisFormElementIsolatedAnswer.TextInputSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.TextInputSchema.shape.typeOfQuestion,
        answer: FormElementAnswer_1.FormElementAnswer.TextFormAnswer(),
    });
    IpisFormElementIsolatedAnswer.TextAreaSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.TextAreaSchema.shape.typeOfQuestion,
        answer: FormElementAnswer_1.FormElementAnswer.TextFormAnswer(),
    });
    IpisFormElementIsolatedAnswer.NumberSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.NumberInputSchema.shape.typeOfQuestion,
        answer: FormElementAnswer_1.FormElementAnswer.NumberFormAnswer(),
    });
    /*
      Not sure how to type this...
      The images will be fetched using presigned links, generated on the server but used on the client.
      Thus, the answer will not be known until returned to the client.
  
      For now, I will set the answer to null.
    */
    IpisFormElementIsolatedAnswer.ServerSideImageGroupSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.ImageGroupSchema.shape.typeOfQuestion,
        answer: centralized_zod_1.z.object({
            value: centralized_zod_1.z.null(),
            imageUploadComment: centralized_zod_1.z.string().nullable(),
        }),
    });
    IpisFormElementIsolatedAnswer.ClientSideImageGroupSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        formElementId: centralized_zod_1.z.string(),
        title: centralized_zod_1.z.string(),
        indexWithinPage: centralized_zod_1.z.number(),
        type: IpisFormElement_1.IpisFormElement.ImageGroupSchema.shape.typeOfQuestion,
        answer: centralized_zod_1.z.object({
            imageUploadComment: centralized_zod_1.z.string().nullable().optional(),
            images: centralized_zod_1.z
                .union([
                FormElementAnswer_1.FormElementAnswer.PreUploadImageSchema,
                FormElementAnswer_1.FormElementAnswer.PostUploadImageSchema,
            ])
                .array(),
        }),
    });
    IpisFormElementIsolatedAnswer.ServerSideSchema = centralized_zod_1.z.union([
        IpisFormElementIsolatedAnswer.MultipleChoiceSchema,
        IpisFormElementIsolatedAnswer.YesNoSchema,
        IpisFormElementIsolatedAnswer.TextInputSchema,
        IpisFormElementIsolatedAnswer.TextAreaSchema,
        IpisFormElementIsolatedAnswer.NumberSchema,
        IpisFormElementIsolatedAnswer.ServerSideImageGroupSchema,
    ]);
    IpisFormElementIsolatedAnswer.ClientSideSchema = centralized_zod_1.z.union([
        IpisFormElementIsolatedAnswer.MultipleChoiceSchema,
        IpisFormElementIsolatedAnswer.YesNoSchema,
        IpisFormElementIsolatedAnswer.TextInputSchema,
        IpisFormElementIsolatedAnswer.TextAreaSchema,
        IpisFormElementIsolatedAnswer.NumberSchema,
        IpisFormElementIsolatedAnswer.ClientSideImageGroupSchema,
    ]);
})(IpisFormElementIsolatedAnswer || (IpisFormElementIsolatedAnswer = {}));
exports.IpisFormElementIsolatedAnswer = IpisFormElementIsolatedAnswer;
